import axiosInstance from './http-common'

class MetadataService {
  async getKeyMetadata(organization: string, project: string, key: string): Promise<string[]> {
    return (await axiosInstance.get(`/${organization}/metadata/${project}/${key}`)).data
  }

  async downloadFileByMetadata(organization: string, project: string, key: string, value: string): Promise<Blob> {
    return (
      await axiosInstance.get(`/${organization}/metadata/${project}/${key}/${value}`, {
        responseType: 'blob',
      })
    ).data
  }
}

export default new MetadataService()
